import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "America/Sao_Paulo";
const DATE_FORMAT = "DD/MM/YYYY";

const toSpToday = () => dayjs().tz(TZ).startOf("day");

export const validateContractDate = ({ value, isPessoaFisica }) => {
  const cleanDigits = (value || "").replace(/\D/g, "");

  if (cleanDigits.length < 8) {
    return { valid: false, message: "Preencha para continuar! 😊" };
  }

  const trimmed = (value || "").trim();

  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
    return { valid: false, message: "Data inválida 🤔" };
  }

  const parsed = dayjs(trimmed, DATE_FORMAT, true);

  if (!parsed.isValid() || parsed.format(DATE_FORMAT) !== trimmed) {
    return { valid: false, message: "Data inválida 🤔" };
  }

  const parsedDate = dayjs
    .tz(parsed.format("YYYY-MM-DD"), "YYYY-MM-DD", TZ)
    .startOf("day");

  const today = toSpToday();

  if (isPessoaFisica) {
    const min = today.subtract(90, "year");
    const max = today.subtract(18, "year");

    if (parsedDate.isBefore(min)) {
      return { valid: false, message: "Idade máxima permitida é 90 anos." };
    }
    if (parsedDate.isAfter(max)) {
      return { valid: false, message: "Idade mínima é 18 anos." };
    }
  } else {
    if (parsed.year() < 1900) {
      return { valid: false, message: "Data de fundação inválida." };
    }
    if (!parsedDate.isBefore(today)) {
      return {
        valid: false,
        message: "Data de fundação deve ser anterior à data atual.",
      };
    }
  }

  return { valid: true, date: parsedDate, message: "" };
};
